import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { IEvent, ILayer, IRequestConfig } from '../types';

import { postEvents } from './postEvents';

dayjs.extend(utc);

const intervalDelay = 5000;

export const layer: ILayer = {
    debug: false,
    events: [],
    push(event: IEvent) {
        const date = dayjs.utc().format('YYYY-MM-DD HH:mm:ss');
        const place = window?.location.pathname ?? '';

        this.events.push({ ...event, date, place });

        if (this.debug) {
            console.log(`event pushed at ${date}`);
        }
    },
    init(config: IRequestConfig) {
        const { agreementNumber, onError, debug = false } = config;

        this.debug = debug;

        setInterval(
            (self => {
                return () => {
                    if (self.events.length) {
                        const eventsClone = [...self.events];

                        // считается самым быстрым способом очистить массив
                        while (self.events.length > 0) {
                            self.events.pop();
                        }

                        (async() => {
                            try {
                                await postEvents({ agreementNumber, events: eventsClone });

                                if (debug) {
                                    console.log('events posted');
                                }
                            } catch (error) {
                                onError(error);
                                this.events = [...self.events, ...eventsClone];
                            }
                        })();
                    }
                };
            })(this),
            intervalDelay,
        );
    },
};
